import { skyFoundationSettings } from '../../../services/configs/configs-service';

export const getInitialState = () => ({
  confirmBottomDialog: {
    isShown: false,
    ctaPrimaryLabel: '',
    message: '',
  },
  notificationStatus: {
    isShown: false,
    message: '',
  },
  activeBlock: null,
  selectedTab: skyFoundationSettings.getPremiumEnabled() ? 0 : 1,
  modalTooltip: {
    widgetId: null,
    selectedPage: 0,
  },
  premiumStatus: {
    isLoading: true,
    isError: false,
    payload: null,
  },
});
